module.exports = __webpack_public_path__ + "static/media/Murugappa_Group_Logo.svg_1.9c39be21.png";